import React from 'react';
import { Link } from 'react-router-dom';

const Portfolio = () => {
  const projects = [
    {
      id: 1,
      image: "https://images.unsplash.com/photo-1597852074816-d933c7d2b988?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      alt: "EV Manufacturing",
      tag: "EV • India",
      title: "EV Manufacturing",
      description: "$10M Roadshow Preparation",
      highlight: "Financial Modeling"
    },
    {
      id: 2,
      image: "https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      alt: "E-Commerce Platform",
      tag: "E-Commerce • India",
      title: "E-Commerce Platform",
      description: "Series A Fundraising",
      highlight: "Investment Marketing Suite"
    },
    {
      id: 3,
      image: "https://images.unsplash.com/photo-1559526324-593bc073d938?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      alt: "Fintech Company",
      tag: "Fintech • USA",
      title: "Fintech Company",
      description: "AI-Powered Financial Model",
      highlight: "Dynamic Forecasting"
    }
  ];

  return (
    <section id="portfolio" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#0F172A] mb-4">Featured Case Studies</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-[#3B82F6] to-emerald-500 mx-auto rounded-full"></div>
          <p className="text-xl text-gray-600 mt-6 max-w-3xl mx-auto">
            Highlights from our recent engagements across industries and geographies.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project) => (
            <div key={project.id} className="group relative rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition duration-300">
              <img 
                src={project.image} 
                alt={project.alt} 
                className="w-full h-64 object-cover transition duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/90 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-6 text-white">
                <span className="bg-[#3435cf] text-white px-2 py-1 rounded text-xs font-medium mb-2">{project.tag}</span>
                <h3 className="text-xl font-semibold mb-2">{project.title}</h3>
                <p className="text-sm opacity-90 mb-4">{project.description}</p>
                <div className="flex items-center">
                  <span className="text-[#93C5FD] font-bold">{project.highlight}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <Link 
            to="/case-studies" 
            className="inline-block border-2 border-[#0F172A] text-[#0F172A] hover:bg-[#0F172A] hover:text-white px-8 py-3 rounded-lg font-semibold transition hover:-translate-y-1 hover:shadow-lg"
          >
            View All Case Studies
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;